// import styled from '@emotion/styled'
import { flatten, kebabCase, isString, isArray } from 'lodash-es'
// import { colors as colorsArr, stages } from '@ow/theme/lib/theme-data'

export const genColors = (props) => {
  const { theme = {} } = props
  const { colors = {} } = theme
  const arr = flatten(
    Object.entries(colors).map(([color, val]) => {
      if (isString(val)) {
        return [`--color-${color}: ${val}`]
      }
      if (isArray(val)) {
        return val.map(([stage, cl]) => {
          return `--color-${color}-${stage}: ${cl}`
        })
      }
      return []
    })
    // colorsArr.map((color) => {
    //   return stages.map((stage) => {
    //     return `--color-${color}-${stage}: ${
    //       colors[color] && colors[color][stage]
    //     }`
    //   })
    // })
  )
  return arr.join(';\n')
}

export const genPalettes = (palettes) => {
  const arr = Object.entries(palettes).map(([color, val]) => {
    return `--ow-${kebabCase(color)}-color: ${val}`
  })
  return arr.join(';\n')
}

/** 将提前定义好的主题色值转换为变量 */
export const transColorToVar = (colorsObj) => {
  const arr = flatten(
    Object.entries(colorsObj).map(([key, colors]) => {
      return Object.entries(colors).map(([level, color]) => {
        return `--ow-color-${key}-${level}:${color}`
      })
    })
  )
  // console.log('theme->>arr', arr)
  return arr.join(';\n')
}

export const genFontColors = (colorsObj) => {
  const arr = flatten(
    Object.entries(colorsObj).map(([key, colors]) => {
      return Object.entries(colors).map(([level, color]) => {
        return `--text-${key}-${level}:${color}`
      })
    })
  )
  // console.log('theme->>arr', arr)
  return arr.join(';\n')
}

export const genFontWeights = (fontWeights) => {
  const arr = Object.entries(fontWeights).map(([key, value]) => {
    return `--font-weight-${key}: ${value}`
  })
  return arr.join(';\n')
}

export const genFontSize = (fontSizes) => {
  const arr = Object.entries(fontSizes).map(([key, value]) => {
    return `--font-size-${key}: ${value}px;--font-line-height-${key}:${
      value + 8
    }px`
  })
  return arr.join(';\n')
}

export const genCompsVars = (comps, props) => {
  const arr = Object.entries(props).map(([key, value]) => {
    return `--${comps}-${kebabCase(key)}: ${value}`
  })
  return arr.join(';\n')
}
